import type { ImgHTMLAttributes } from 'react';
import lockupDarkAsset from '../assets/lockup-dark.png';
import lockupLightAsset from '../assets/lockup-light.png';
import lockupTagDarkAsset from '../assets/lockup-tag-dark.png';
import markDarkAsset from '../assets/mark-dark.png';

type AssetLike = string | { src: string };
const srcOf = (a: AssetLike): string => (typeof a === 'string' ? a : a.src);

const ASSETS = {
  'lockup-dark': srcOf(lockupDarkAsset),
  'lockup-light': srcOf(lockupLightAsset),
  'lockup-tag-dark': srcOf(lockupTagDarkAsset),
  'mark-dark': srcOf(markDarkAsset),
} as const;

export type LogoVariant = keyof typeof ASSETS;

interface LogoProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  variant?: LogoVariant;
  alt?: string;
}

export function Logo({ variant = 'lockup-dark', alt = 'clickt.link', ...props }: LogoProps) {
  return <img src={ASSETS[variant]} {...props} alt={alt} />;
}
